/**
 * Traditional Chinese strings for the player's own keys.
 *
 * Media Chrome ships this language for its controls; the keys the player adds,
 * casting, preview and its error messages, would otherwise fall back to English.
 */
import { ZhTw as MediaChromeZhTw } from 'media-chrome/lang/zh-TW.js';
import type { TranslateDictionary } from './en.js';

export const ZhTw: TranslateDictionary = {
  ...MediaChromeZhTw,
  'Casting to {device}': '正在投放至 {device}',
  preview: '預覽',
  "This video cannot be played on your device because it doesn't meet the content protection requirements.":
    '此影片無法在您的裝置上播放，因為裝置不符合內容保護要求。',
  'There was an error with the content protection system.':
    '內容保護系統發生錯誤。',
  'This video requires a secure connection (HTTPS) to play DRM-protected content.':
    '此影片需要安全連線 (HTTPS) 才能播放受 DRM 保護的內容。',
  'An error occurred during playback. The media could not be loaded.':
    '播放過程中發生錯誤，無法載入媒體。',
  'This video uses a codec (HEVC) that is not supported by your browser. Please try a different browser such as Chrome or Safari.':
    '此影片使用的編解碼器 (HEVC) 不受您的瀏覽器支援。請嘗試其他瀏覽器，例如 Chrome 或 Safari。',
  'There was an error during initialization of the DRM system.':
    '初始化 DRM 系統時發生錯誤。',
  'The content license has expired.': '內容授權已過期。',
  'This video is not available.': '此影片無法使用。',
  'This video could not be found.': '找不到此影片。',
};
